import { ParentComponent } from "solid-js";

export const PageSection: ParentComponent<{}> = (props) => (
  <section>{props.children}</section>
);
export default PageSection;
